export default __webpack_public_path__ + "static/webinars-demo-modal-d917e3c51bfe4121f067166b3f647002.png";